import React, { Component } from 'react';
import PropTypes from 'prop-types';
import IconSearch20 from '../../assets/icons/IconSearch20';
import './SearchInput.scss';

class SearchInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: '',
    };

    this.searchInputId = `search-input-${Date.now()}-${Math.floor(Math.random() * 10000)}`;
  }

  handleOnChange(e) {
    this.setState({
      value: e.target.value,
    });
  }

  handleOnSubmit(e) {
    e.preventDefault();
    const { onSubmit } = this.props;
    onSubmit(this.state.value);
  }

  render() {
    const { value } = this.state;

    return (
      <div className="bt-search-input">
        <div className="bt-search-input-form">
          <form aria-label="Search Form" onSubmit={(e) => this.handleOnSubmit(e)}>
            <button type="submit" className="bt-search-input-icon" aria-label="Submit search">
              {IconSearch20}
            </button>
            <label htmlFor={this.searchInputId} className="sr-only">
              Search site
            </label>
            <input
              type="text"
              aria-label="Search all"
              id={this.searchInputId}
              value={value}
              placeholder="Search all"
              onChange={(e) => this.handleOnChange(e)}
            />
          </form>
        </div>
      </div>
    );
  }
}

SearchInput.propTypes = {
  onSubmit: PropTypes.func,
};

SearchInput.defaultProps = {
  onSubmit: () => false,
};

export default SearchInput;
